import { useEffect, useMemo, useState } from 'react'
import { wrap } from 'comlink'

const useWorker = ({ getWorkerInstance }) => {
  const [worker, setWorker] = useState()
  useEffect(() => {
    setWorker(getWorkerInstance())
    return () => {
      worker && worker.terminate()
    }
    // on component mount/unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const proxy = useMemo(() => wrap(worker), [worker])
  return [proxy]
}

export default useWorker
